import { useStatsigClient } from '@statsig/react-bindings'
import { usePathname } from 'next/navigation'
import { useMemo } from 'react'

const includedPaths = [
  '/credit-cards/tips/pay-0-interest-tfh-chap/',
  '/credit-cards/tips/pay-0-interest-tfh-mpc/',
  '/credit-cards/tips/pay-0-interest-tfh-hpc/',
  '/credit-cards/tips/pay-0-interest-tfh-st/',
]

export const useShouldShowNewTFHDesign = () => {
  const statsigClient = useStatsigClient()
  const pathname = usePathname()

  const shouldShowNewTFHDesign = useMemo(() => {
    const isValidPath = includedPaths.includes(pathname)

    return isValidPath
      ? statsigClient
          .getExperiment('exp_383_new_tfh_design')
          .get('new_tfh_design', false)
      : false
  }, [statsigClient, pathname])

  return shouldShowNewTFHDesign
}
